import { log } from './log';
import { appAssetsOrigin, getPathDetails } from './environments';
import { request } from './request';

export const views = new Map();

const viewLoadPromises = new Map();

export const requestWithFallback = async (
  url,
  fallbackUrl,
  headers = {
    accept: 'text/html',
  },
) => {
  const res = await request(url, { headers });
  if (res.ok) return res;
  return request(fallbackUrl, { headers });
};

const { lang } = getPathDetails();

async function loadView(name) {
  const viewForLang = (l) => `${appAssetsOrigin}/assets/views/${name}_${l}.html`;
  try {
    const res = await requestWithFallback(viewForLang(lang), viewForLang('en'));

    if (res.ok) {
      const html = await res.text();

      views.set(name, (data) => {
        let result = '';

        log(!data ? `No data for ${name} template` : `Processed data for ${name} template`);

        try {
          // eslint-disable-next-line no-new-func
          result = new Function('data', `return \`${html}\``)(data);
        } catch (err) {
          log(err, 'error');
        }

        return result;
      });

      log(`Retrieved template: ${name}`);
    }
  } catch {
    log(`Failed to retrieve template: ${name}`);
  }
}

function scheduleViewLoad(name) {
  if (!viewLoadPromises.has(name)) {
    viewLoadPromises.set(name, loadView(name));
  }
  return viewLoadPromises.get(name);
}

/** Start loading view templates without blocking; safe to call once at app init. */
export function startViewsLoad(viewNames = []) {
  viewNames.forEach(scheduleViewLoad);
  return viewLoadPromises.size ? Promise.all([...viewLoadPromises.values()]) : null;
}

/** Await specific templates (others may still be loading in the background). */
export async function ensureViewsLoaded(viewNames = []) {
  const names = [...new Set(viewNames.filter(Boolean))];
  if (!names.length) {
    return;
  }
  names.forEach(scheduleViewLoad);
  await Promise.all(names.map((name) => viewLoadPromises.get(name)));
}

/** Await every template started via {@link startViewsLoad}. */
export async function ensureAllViewsLoaded() {
  if (!viewLoadPromises.size) {
    return;
  }
  await Promise.all([...viewLoadPromises.values()]);
}

export async function load(arg = []) {
  arg.forEach(scheduleViewLoad);
  await ensureViewsLoaded(arg);
}

export const viewToDomElement = (viewString) => {
  const placeholder = document.createElement('div');
  placeholder.innerHTML = viewString;

  return placeholder.removeChild(placeholder.firstChild);
};
